export default __webpack_public_path__ + "static/media/cart.bd0a9f72.svg";